<div class="table-responsive">
    <table mat-table [dataSource]="history()">
        <ng-container matColumnDef="eventType">
            <th mat-header-cell *matHeaderCellDef>{{ 'ADMIN.DAYS_LEFT.HISTORY_COL_EVENT_TYPE' | translate }}</th>
            <td mat-cell *matCellDef="let row">
                <span class="nh-chip" [class]="chipClass()">
                    <mat-icon class="nh-chip-icon">{{ chipIcon(row) }}</mat-icon>
                    {{ 'ADMIN.DAYS_LEFT.EVENT_TYPE.' + row.eventType | translate }}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="eventDetails">
            <th mat-header-cell *matHeaderCellDef>{{ 'ADMIN.DAYS_LEFT.HISTORY_COL_DETAILS' | translate }}</th>
            <td mat-cell *matCellDef="let row" class="event-details-cell">{{ row | notificationEventDetails }}</td>
        </ng-container>

        <ng-container matColumnDef="lastModifiedBy">
            <th mat-header-cell *matHeaderCellDef>{{ 'ADMIN.DAYS_LEFT.HISTORY_COL_MODIFIED_BY' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.lastModifiedBy }}</td>
        </ng-container>

        <ng-container matColumnDef="eventTimestamp">
            <th mat-header-cell *matHeaderCellDef>{{ 'ADMIN.DAYS_LEFT.HISTORY_COL_TIMESTAMP' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.eventTimestamp | date: dateFormat }}</td>
        </ng-container>

        <ng-container matColumnDef="recipients">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
                @if (row.result === Result.ERROR) {
                <button mat-icon-button (click)="openDetail(row)" [attr.aria-label]="'ADMIN.DAYS_LEFT.HISTORY_VIEW_ERROR_BTN' | translate">
                    <mat-icon class="view-icon view-icon--error">warning</mat-icon>
                </button>
                } @else if (row.category === Category.EMAIL) {
                <button mat-icon-button (click)="openDetail(row)" [attr.aria-label]="'ADMIN.DAYS_LEFT.HISTORY_VIEW_DETAILS_BTN' | translate">
                    <mat-icon class="view-icon">visibility</mat-icon>
                </button>
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="noData">
            <td mat-footer-cell *matFooterCellDef [attr.colspan]="tableColumns.length">
                {{ 'ADMIN.DAYS_LEFT.HISTORY_NO_RECORDS' | translate }}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
        <tr mat-footer-row *matFooterRowDef="['noData']" [hidden]="history().length > 0"></tr>
    </table>
</div>